/* eslint-disable max-len */
import React from 'react';

const CalloutAssessment = () => (
  <div id="schedule-assessment" className="schedule-assessment">
    <h4 className="schedule-assessment__header">Take the Next Step</h4>
    <p className="schedule-assessment__copy">Call or visit this dealer today to learn more.</p>
  </div>
);

export default CalloutAssessment;



// WEBPACK FOOTER //
// ./src/views/Home/components/CalloutAssessment.js